import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
  Divider,
  Chip,
  CircularProgress,
  Alert,
  Button,
  Stack
} from "@mui/material";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import PersonIcon from "@mui/icons-material/Person";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import axiosInstance from "../../api/axiosConfig";

const Branches = () => {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchBranches();
  }, []);

  const fetchBranches = async () => {
    try {
      setLoading(true);

      const response = await axiosInstance.get("/branch/active");
      console.log("Branches API Response:", response.data);
      setBranches(response.data || []);
      setError("");
    } catch (err) {
      console.error(err);
      setError("Failed to load branches");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "50vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      {/* Title */}
      <Box textAlign="center" mb={6}>
        <Typography
          variant="h3"
          fontWeight="bold"
          sx={{ mb: 2 }}
        >
          Our Branches
        </Typography>

        <Typography variant="subtitle1" color="text.secondary">
          Kavya Institute of Fire & Industrial Safety
        </Typography>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      <Grid container spacing={4}>
        {branches.map((branch, index) => (
          <Grid item xs={12} md={6} key={branch.branchId}>
            <Card
              sx={{
                height: "100%",
                borderRadius: 4,
                boxShadow: 4,
                transition: "all .3s ease",
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: 10,
                },
              }}
            >
              <CardContent>
                <Box mb={2}>
                  <Chip
                    label={`Branch ${index + 1}`}
                    color="primary"
                  />
                </Box>

                <Typography
                  variant="h5"
                  fontWeight="bold"
                  gutterBottom
                >
                  {branch.branchName}
                </Typography>

                <Divider sx={{ mb: 2 }} />

                {branch.directorName && (
                  <Box display="flex" mb={1}>
                    <PersonIcon sx={{ mr: 1 }} />
                    <Typography>
                      Director: <b>{branch.directorName}</b>
                    </Typography>
                  </Box>
                )}

                {branch.branchHeadName && (
                  <Box display="flex" mb={1}>
                    <PersonIcon sx={{ mr: 1 }} />
                    <Typography>
                      Branch Head: <b>{branch.branchHeadName}</b>
                    </Typography>
                  </Box>
                )}

                {branch.coordinatorName && (
                  <Box display="flex" mb={1}>
                    <PersonIcon sx={{ mr: 1 }} />
                    <Typography>
                      Coordinator: <b>{branch.coordinatorName}</b>
                    </Typography>
                  </Box>
                )}

                {branch.primaryPhone && (
                  <Box display="flex" mb={1}>
                    <PhoneIcon sx={{ mr: 1 }} />
                    <Typography>
                      {branch.primaryPhone}
                    </Typography>
                  </Box>
                )}

                {branch.secondaryPhone && (
                  <Box display="flex" mb={1}>
                    <PhoneIcon sx={{ mr: 1 }} />
                    <Typography>
                      {branch.secondaryPhone}
                    </Typography>
                  </Box>
                )}

                <Box display="flex" mt={2}>
                  <LocationOnIcon sx={{ mr: 1 }} />
                  <Typography>
                    {branch.address}
                  </Typography>
                </Box>

                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  mt={4}
                >
                  <Button
                    fullWidth
                    variant="contained"
                    startIcon={<PhoneIcon />}
                    href={`tel:${branch.primaryPhone}`}
                  >
                    Call Now
                  </Button>

                  <Button
                    fullWidth
                    variant="outlined"
                    color="success"
                    startIcon={<WhatsAppIcon />}
                    href={`https://wa.me/91${branch.primaryPhone}`}
                    target="_blank"
                  >
                    WhatsApp
                  </Button>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Branches;